/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form, Spin, Checkbox, Slider, Switch, InputNumber } from 'antd';
import { useAppContext } from "../../../context/appContext";
import { CloseOutlined } from '@ant-design/icons';
import fetchUserSettingsInterval from "../../common/helpers/fetch-user-settings-interval";
import updateUserSettingsInterval from "../../common/helpers/update-user-settings-interval";
import { userId } from "../../../context/appContext";
import { DeleteOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const BulkUpdate = ({ displayBulkUpdate, setDisplayBulkUpdate, applyBulkUpdate, markets }) => {

    const [intervalSettings, setIntervalSettings] = useState({
        edge_case_interval: null,
        balance_interval: null,
        non_stream_interval: null,
    })

    const fieldKeyValue = {
        'symbol': { type: 'dropdown', label: 'Symbol', options: [...(markets || []).map(m => m.symbol)] },
        'conversion': { type: 'conversion', label: 'Conversion' },
        'spread': { type: 'number', label: 'Spread' },
        'timer':  { type: 'number', label: 'Timer' },
        'side':  { type: 'dropdown', label: 'Side', options: ['buy', 'sell'] },
        'minimum_size':  { type: 'number', label: 'Minimum size' },
        'maximum_size':  { type: 'number', label: 'Maximum size' },
        'sensitivity':  { type: 'number', label: 'Sensitivity' },
        'paused':  { type: 'boolean', label: 'Paused' },
    }
    
    const [showAddFilter, setShowAddFilter] = useState(false);
 
    const [fields, setFields] = useState([
        { value:'symbol', label: 'Symbol' },
        { value:'conversion', label: 'Conversion' },
        { value:'spread', label: 'Spread' },
        { value:'timer', label: 'Timer' },
        { value:'side', label: 'Side' },
        { value:'paused', label: 'Paused' },
        { value:'minimum_size', label: 'Minimum size' },
        { value:'maximum_size', label: 'Maximum size' },
        { value:'sensitivity', label: 'Sensitivity' },
    ]);

    const [field, setField] = useState();

    const [updateField, setUpdateField] = useState({})

    function calculateConversion(fn, price) {
        return new Function(`const x = ${price}; return ${fn}`)();
    }

    const goBack = () => {
        setDisplayBulkUpdate(false)
    }

    const handleUpdateField = () => {
        if(updateField?.field == 'conversion') {
            try {

                calculateConversion(updateField.value, 10)
            } catch (err) {
                message.error('Conversion formula is not in correct format');
                return;
            }
        }

        applyBulkUpdate(updateField);
        // setUpdateField();
        // setField();
        setDisplayBulkUpdate(false);
    }
    return (
        <>
            <Modal
                maskClosable={false}
                closeIcon={<CloseOutlined style={{ color: "white" }} />}
                bodyStyle={{
                    backgroundColor: 'black',
                    border: "1px solid grey"
                }}
                visible={displayBulkUpdate} footer={null} onCancel={() => { setDisplayBulkUpdate(false); }}>
                <div style={{ fontWeight: "600", color: "white" }}>Bulk Update</div>

                <div style={{ color: "white", marginTop: 30, marginBottom: 40 }}>
                    <label>Field</label>
                    <Select
                        showSearch
                        style={{ width: "100%", marginTop: 10 }}
                        placeholder="Select field"
                        value={field}
                        onChange={(value) => {
                            setField(value);
                            setUpdateField({ field: value, value: null });
                        }}
                    >
                        {fields.map(field => <Option value={field.value}>{field.label}</Option>)}
                    </Select>
                </div>

                {field && <div>
                    <div style={{ color: "white", margin: "30px 0" }}>
                            <label>{fieldKeyValue[field].label}: </label>
                            {fieldKeyValue[field].type == 'string' && <Input value={updateField?.value} onChange={(e) => {
                                setUpdateField({ field: field, value: e.target.value })
                            }} style={{ marginTop: 10 }} placeholder={fieldKeyValue[field].label} />}
                            {fieldKeyValue[field].type == 'number' && <InputNumber style={{ marginLeft: 5 }} value={updateField?.value} onChange={(e) => { setUpdateField({ field: field, value: e }) }} />}
                            {fieldKeyValue[field].type == 'boolean' &&  <Switch size="small" checked={updateField?.value} onChange={(e) => {
                                setUpdateField({ field: field, value: e })
                            }} />}
                            {fieldKeyValue[field].type == 'dropdown' &&  <Select
                                showSearch
                                style={{ width: "100%", marginTop: 10 }}
                                placeholder="Select value"
                                value={updateField?.value}
                                onChange={(e) => {
                                    setUpdateField({ field: field, value: e })
                                }}
                            >
                            {fieldKeyValue[field]?.options.map(f => <Option value={f}>{f}</Option>)}
                            </Select>}
                            {fieldKeyValue[field].type == 'conversion'&& 
                                <>
                
                                <div style={{ color: "white", marginBottom: 50, marginTop: 10 }}>
                                    <label>Value:x (price)</label>
                                    <div style={{ marginTop: 10, marginBottom: 10 }}>
                                        <div>add: '+'</div>
                                        <div>sub: '-'</div>
                                        <div>div: '/'</div>
                                        <div>mlt: '*'</div>
                                        <div>mod: '%'</div>
                                        <div>exp: '^'</div>
                                    </div>
                                    <div style={{ fontStyle: "italic" }}>example: 3^x*12/5*9+9.4*2</div>
                                    <TextArea value={updateField?.value} onChange={(e) => { 
                                    

                                        setUpdateField({ field: field, value: e.target.value || undefined })
                                        }} style={{ marginTop: 10 }} placeholder="Create conversion formula" rows={3} />
                                </div>
                            </>
                            }
                        </div>
                    </div>}

                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                    <Button onClick={() => { setDisplayBulkUpdate(false); }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                    <Button onClick={() => {
                       handleUpdateField();
                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
                </div>
            </Modal >
        </>
    );
};

export default BulkUpdate;